(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LongTermCareCostsCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["LongTermCareCostsCalculator"] = factory();
	else
		root["LongTermCareCostsCalculator"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition